import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

const Flags = ({ flagData, listing }) => {
  const flagArray = flagData ? flagData : [];
  if (moment(listing.utcNewUntil).isAfter(moment())) {
    flagArray.push("New");
  }

  const openHouses = listing.openhouses
    ? listing.openhouses.filter(function (openhouse) {
        return (
          moment(openhouse.utcEnd).isAfter(moment.utc()) &&
          openhouse.brokerOnly === false
        );
      })
    : [];
  const currentOpenHouse = openHouses.length > 0 ? openHouses[0] : null;
  if (currentOpenHouse) {
    flagArray.push(
      currentOpenHouse.isVirtual ? (
        "Virtual Open House"
      ) : (
        <span>
          {"Open House "}
          <span className="oh-date">{currentOpenHouse.display}</span>
        </span>
      )
    );
  }

  if (listing.isComingSoon) {
    flagArray.push("Coming Soon");
  }

  if (listing.isUnderContract && !listing.showPendingAsActive) {
    flagArray.push("In Contract");
  }

  if (listing.hasVideos) {
    flagArray.push("Video");
  }

  if (listing.noFeeRental) {
    flagArray.push("No Fee Rental");
  }

  // show top 2 banners
  const flags = flagArray.slice(0, 2).map(function (flag, index) {
    return (
      <div className="list-label" key={index}>
        {flag}
      </div>
    );
  });
  return <div className="labels">{flags}</div>;
};

Flags.propTypes = {
  flagData: PropTypes.array,
  listing: PropTypes.object.isRequired,
};

export default Flags;



// WEBPACK FOOTER //
// ./src/components/search/result/flags.jsx